const LogoutIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M19.1152 10.6251L19.1152 10.6251L19.1133 10.6273L15.0072
                15.4183C14.6658 15.8167 14.0661 15.8628 13.6677 15.5214C13.2693
                15.18 13.2231 14.5802 13.5646 14.1819L15.9808 11.3626L16.3345
                10.9499L15.791 10.9499L6.49726 10.9499C5.97259 10.9499 5.54726
                10.5246 5.54726 9.99992C5.54726 9.47525 5.97259 9.04992 6.49726
                9.04992L15.7908 9.04992L16.3343 9.04992L15.9807 8.63723L13.5646
                5.81814C13.2231 5.41976 13.2693 4.82002 13.6677 4.4786C14.0661
                4.13717 14.6658 4.18333 15.0072 4.58171L19.1134 9.37274L19.1133
                9.37275L19.1152 9.37486C19.1633 9.42977 19.2041 9.48908 19.2375
                9.55149L19.2376 9.55172C19.3127 9.6917 19.3498 9.84584 19.3497
                9.99987C19.3496 10.2252 19.27 10.4485 19.1152 10.6251ZM9.04973
                3.9999C9.04973 3.19909 8.40054 2.5499 7.59973 2.5499L3.99973
                2.5499C3.19892 2.5499 2.54973 3.19909 2.54973 3.9999L2.54973
                15.9999C2.54973 16.8007 3.19892 17.4499 3.99973 17.4499L7.59973
                17.4499C8.40054 17.4499 9.04973 16.8007 9.04973 15.9999L9.04973
                14.1999C9.04973 13.6752 9.47506 13.2499 9.99973 13.2499C10.5244
                13.2499 10.9497 13.6752 10.9497 14.1999L10.9497 15.9999C10.9497
                17.8501 9.44988 19.3499 7.59973 19.3499L3.99973 19.3499C2.14958
                19.3499 0.64973 17.8501 0.64973 15.9999L0.649731 3.9999C0.649731
                2.14975 2.14958 0.649902 3.99973 0.649902L7.59973 0.649902C9.44988
                0.649902 10.9497 2.14975 10.9497 3.9999L10.9497 5.7999C10.9497 6.32457
                10.5244 6.7499 9.99973 6.7499C9.47506 6.7499 9.04973 6.32457 9.04973
                5.7999L9.04973 3.9999Z"
                fill="currentColor" stroke="#272652" stroke-width="0.5" stroke-linecap="round"/>
        </svg>
    );
}

export default LogoutIcon;